exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shop_code[data-v-79d7880f]{padding:20px 30px;background-color:#f5f5f5}\n", ""]);

// exports
